// API URLの設定
export const API_URL = process.env.VUE_APP_API_URL || "/api";
export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "";
